import PropTypes from "prop-types"
import React, { useEffect, useState, useRef, useCallback } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom";
import Utils from '../../pages/Utility';
import { get } from "../../helpers/api_helper";

//i18n
import { withTranslation } from "react-i18next";

// redux
import { connect } from "react-redux";
import { getNotiSuccess } from "../../store/actions";

const SidebarContent = props => {
  // console.log('props on slidebar content', props);
  const [subMenu, setSubMenu] = useState(false);
  const [isModerator, setIsModerator] = useState(false);
  const [isDealer, setIsDealer] = useState(false);
  const [isAutoLead, setIsLeadAuto] = useState(false);


  const ref = useRef()
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        console.log('checking menu item', pathName, items[i].pathname)
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    item.style.color = Utils.themeColor;
    item.style.fontWeight = 'bold';
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false
    }
    scrollElement(item);
    return false
  }

  return (
    <React.Fragment>
      <SimpleBar ref={ref} className="vertical-simplebar">
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>
            <li>
              <Link to="/dashboard" className="waves-effect">
                <i className="mdi mdi-airplay" style={{ color: Utils.themeColor }}></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li>
            {props.user?.role == 'Admin' &&
              <>
                <li>
                  <Link to="/home" className="waves-effect">
                    <i className="mdi mdi-image-multiple" style={{ color: Utils.themeColor }}></i>
                    <span>{props.t("Home Banner")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/experience" className="waves-effect">
                    <i className="mdi mdi-briefcase-check" style={{ color: Utils.themeColor }}></i>
                    <span>{props.t("Experience")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/destination" className="waves-effect">
                    <i className="mdi mdi-cards-variant" style={{ color: Utils.themeColor }}></i>
                    <span>{props.t("Destination")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/retreat" className="waves-effect">
                    <i className="mdi mdi-gift" style={{ color: Utils.themeColor }}></i>
                    <span>{props.t("Retreats")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/artist" className="waves-effect">
                    <i className="mdi mdi-account-multiple" style={{ color: Utils.themeColor }}></i>
                    <span>{props.t("Artist")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/tour" className="waves-effect">
                    <i className="mdi mdi-sign-direction" style={{ color: Utils.themeColor }}></i>
                    <span>{props.t("Tours")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/testimonial" className="waves-effect">
                    <i className="mdi mdi-account-heart" style={{ color: Utils.themeColor }}></i>
                    <span>{props.t("Testimonial")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/gallery" className="waves-effect">
                    <i className="mdi mdi-post" style={{ color: Utils.themeColor }}></i>
                    <span>{props.t("Gallery")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/blog" className="waves-effect">
                    <i className="mdi mdi-post-outline" style={{ color: Utils.themeColor }}></i>
                    <span>{props.t("Blogs")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/store" className="waves-effect">
                    <i className="mdi mdi-post" style={{ color: Utils.themeColor }}></i>
                    <span>{props.t("Image Store")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/affiliation" className="waves-effect">
                    <i className="mdi mdi-draw" style={{ color: Utils.themeColor }}></i>
                    <span>{props.t("Affiliation")}</span>
                  </Link>
                </li>
                {/* <li>
                  <Link to="/users" className="waves-effect">
                    <i className="mdi mdi-account-multiple" style={{ color: Utils.themeColor }}></i>
                    <span>{props.t("Users")}</span>
                  </Link>
                </li> */}
                <li>
                  <Link to={"/#"} className={"has-arrow waves-effect"} onClick={() => setSubMenu(!subMenu)}>
                    <i className="mdi mdi-account-circle-outline" style={{ color: Utils.themeColor }}></i>
                    <span>{props.t("Users")}</span>
                  </Link>
                  <ul className={"sub-menu"}>
                    <li><Link to="/users/enquiry">{props.t("Enquiry")}</Link></li>
                    <li><Link to="/users/subscriber">{props.t("Subscriber")}</Link></li>
                    <li><Link to="/users/booking">{props.t("Bookings")}</Link></li>
                  </ul>
                </li>
                {/* <li>
                  <Link to={"/#"} className={"has-arrow waves-effect"} onClick={() => setSubMenu(!subMenu)}>
                    <i className="mdi mdi-account-circle-outline" style={{ color: Utils.themeColor }}></i>
                    <span>{props.t("App Management")}</span>
                  </Link>
                  <ul className={"sub-menu"}>
                    <li><Link to="/app/hero_banner">{props.t("Hero Banner")}</Link></li>
                    <li><Link to="/app/banner_1">{props.t("Banner 1")}</Link></li>
                    <li><Link to="/app/banner_2">{props.t("Banner 2")}</Link></li>
                  </ul>
                </li> */}
              </>
            }
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment >
  )
}

const mapStateToProps = state => {
  const { notis } = state.notification;
  return { notis }
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  getNotiSuccess: PropTypes.func,
}

export default withRouter(withTranslation()(connect(mapStateToProps, { getNotiSuccess })(SidebarContent)))